import React from 'react'

import './skills-list.scss'
import CTAButton from '../CTA/cta'

class SkillsList extends React.Component {
  renderCTAButton(ctaContent) {
    if (ctaContent) {
      return (
        <CTAButton
          title={ctaContent.title}
          url={ctaContent.url}
          style={ctaContent.style} />
      )
    } else {
      return null
    }
  }


  render() {
    const content = this.props.content
    const renderedComponents = this.renderCTAButton(content.cta)
    return (
      <div data-cy="skills-list" className="skills-container standard-container">
        <div className="header">
          <h3>{content.heading ? content.heading : null}</h3>
          <p>{content.body && content.body.body ? content.body.body : null}</p>
        </div>
        
        <ol className="skills-list">
          { content.skillItems.map((item, index) => {
            return (
              <li key={item.id}>
                <h4>{item.title ? item.title : ''}</h4>
                <p>{item.body && item.body.body ? item.body.body : null}</p>
              </li>
            )
          })}
        </ol>
        
        <div className="cta-container">
          { renderedComponents }
        </div>
      </div>
    )
  }
}

export default SkillsList


// WEBPACK FOOTER //
// ./src/components/SkillsList/skills-list.js